import * as React from 'react';
import {CSSProperties} from 'react';
import AccountingNote from "../../../../model/invoice/note/AccountingNote";
import {default as CommonStreamItem} from "../../../../hiberUiKit/src/molecules/StreamItem/CommonStreamItem";
import {RootState} from "../../../../store/reducer/root/RootState";
import {connect, Dispatch} from "react-redux";
import Toast from "../../../helper/Toast";
import {notifyBugsnagAndShowToast} from "../../../../utils/Utils";
import {OnSuccess} from "../../../../store/action/actionHelpers";
import {deleteInvoiceNote} from "../../../../store/action/note/notes";

interface ReduxProps {
	/**
	 * Logged user id
	 */
	loggedUserId: string
}

interface DispatchProps {
	/**
	 * Delete note action.
	 * @param invoiceId
	 * @param noteId
	 * @param onSuccess
	 */
	deleteNote: (invoiceId: string, noteId: string, onSuccess: OnSuccess) => void;
}

interface ComponentProps {
	/**
	 * Invoice activity to display.
	 */
	activity: AccountingNote;
	/**
	 * Indicates if history item is active.
	 */
	isActive?: boolean;
	/**
	 * On edit note click.
	 * @param {AccountingNote} InvoiceNote note to edit.
	 */
	onEditNoteClick?: (note: AccountingNote) => void;
	/**
	 * On delete note success callback.
	 * @param {AccountingNote} note deleted note.
	 */
	onDeleteNoteSuccess?: (note: AccountingNote) => void;
	/**
	 * Indicates if action are disabled
	 */
	readOnly?: boolean
	/**
	 * Related invoice identifier (optional because not needed when readOnly = true)
	 */
	invoiceId?: string;
}

type Props = ComponentProps & ReduxProps & DispatchProps;

class InvoiceActivityNoteItem extends React.Component<Props, {}> {
	/**
	 * Indicates if user can edit and delete this note.
	 */
	editable: boolean;
	/**
	 * Activity item container style.
	 */
	containerStyle: CSSProperties;

	constructor(props: Props) {
		super(props);
		this.editable = props.activity.creator.id === props.loggedUserId && !props.readOnly;
		this.editNoteClick = this.editNoteClick.bind(this);
		this.onDeleteNoteSuccess = this.onDeleteNoteSuccess.bind(this);
		this.deleteNoteClick = (this.editable && this.props.invoiceId) ? this.deleteNoteClick.bind(this) : undefined;
		this.containerStyle = {cursor: this.editable ? "pointer" : "auto"};
	}

	render() {
		return (
			<div onClick={this.editNoteClick} style={this.containerStyle}>
				<CommonStreamItem event={this.props.activity}
								  onDeleteClick={this.deleteNoteClick}/>
			</div>
		);
	}

	deleteNoteClick() {
		this.props.deleteNote(this.props.invoiceId, this.props.activity.id, this.onDeleteNoteSuccess);
	}

	onDeleteNoteSuccess() {
		Toast.success("Note has been deleted", "Delete note");
		this.props.onDeleteNoteSuccess && this.props.onDeleteNoteSuccess(this.props.activity);
	}

	editNoteClick() {
		(this.editable && this.props.onEditNoteClick) && this.props.onEditNoteClick(this.props.activity);
	}
}

function mapStateToProps(state: RootState) {
	return {loggedUserId: state.user.user.get.id}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		deleteNote: (invoiceId: string, noteId: string, onSuccess: OnSuccess) => dispatch(
			deleteInvoiceNote(noteId, invoiceId, onSuccess, (error) => notifyBugsnagAndShowToast(error, "Delete note")))
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceActivityNoteItem);
